/*** IMPORTS FROM imports-loader ***/
var global = window;

export var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};
